import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInAnonymously ,signOut, OAuthProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword, SAMLAuthProvider, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getCookie } from "./cookies";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app, "chatbot");


//export const provider = new GoogleAuthProvider();
export const googleProvider = new GoogleAuthProvider();

//export const microsoftProvider = new OAuthProvider('microsoft.com');

// Función para iniciar sesión con Google y retornar los datos del usuario
export const signInWithGoogle = async () => {
    try {
      googleProvider.setCustomParameters({prompt:'select_account'});
      const result = await signInWithPopup(auth, googleProvider);
      return result.user;
    } catch (error) {
      console.error("Error al iniciar sesión con Google:", error);
      throw error;
    }
  };
  
export const signInWithSaml= async (providerId:string) => {
  try {
    const provider = new SAMLAuthProvider(providerId);
    const result = await signInWithPopup(auth, provider); 
    return result.user;
  } catch (error) {
    console.error("Error al iniciar sesión con SAML:", error);
    throw error;
  }
};

// Login con Microsoft
export const signInWithMicrosoft = async () => {
  try {
    var microsoftProvider = new OAuthProvider('microsoft.com');
    microsoftProvider.setCustomParameters({prompt:'select_account'});
    const result = await signInWithPopup(auth, microsoftProvider);
    return result.user;
  } catch (error) {
    console.error("Error al iniciar sesión con Microsoft:", error);
    throw error;
  }
};

// Acceso sin contraseña por enlace al correo (passwordless).
// El correo se guarda en localStorage para completar el ingreso cuando el
// usuario vuelve desde el enlace en este mismo navegador.
const EMAIL_FOR_SIGNIN_KEY = "chatbot_email_for_signin";

// Guarda el correo pendiente cuando el enlace lo envía el backend
// (no pasa por sendEmailSignInLink pero el retorno usa la misma clave)
export const rememberEmailForSignIn = (email: string) => {
  window.localStorage.setItem(EMAIL_FOR_SIGNIN_KEY, email);
};

export const sendEmailSignInLink = async (email: string) => {
  await sendSignInLinkToEmail(auth, email, {
    // Firebase agrega los parámetros del enlace (oobCode, mode, apiKey) a esta
    // URL, así el usuario regresa a la misma vista/proyecto desde donde pidió el enlace.
    url: window.location.href,
    handleCodeInApp: true,
  });
  window.localStorage.setItem(EMAIL_FOR_SIGNIN_KEY, email);
};

export const isEmailSignInLink = (url: string) => isSignInWithEmailLink(auth, url);

// Completa el ingreso cuando el usuario abre el enlace del correo
export const completeEmailLinkSignIn = async (link: string) => {
  let email = window.localStorage.getItem(EMAIL_FOR_SIGNIN_KEY);
  if (!email) {
    // abrió el enlace en otro dispositivo/navegador: confirmar identidad
    email = window.prompt("Confirma tu correo para completar el ingreso:");
  }
  if (!email) return null;
  const result = await signInWithEmailLink(auth, email.trim().toLowerCase(), link);
  window.localStorage.removeItem(EMAIL_FOR_SIGNIN_KEY);
  return result.user;
};

// Iniciar sesión con Email y Contraseña
export const signInWithEmail = async (email: string, password: string) => {
  const result = await signInWithEmailAndPassword(auth, email, password);
  return result.user; 
};

// Registrarse con Email y Contraseña
export const signUpWithEmail = async (email: string, password: string) => {
  const result = await createUserWithEmailAndPassword(auth, email, password);
  return result.user;
};


 // Iniciar sesión de forma anónima
export const signInAnonymouslyFirebase = async () => {
  try {
    const result = await signInAnonymously(auth);
    return result.user; // Retorna los datos del usuario anónimo
  } catch (error) {
    console.error('Error al iniciar sesión anónimamente:', error);
    throw error;
  }
};

function generateUUID() {
  // RFC4122 v4 compatible
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const signInAnonymous = async (generic:boolean=false) => {
  try {
    const clientId = getCookie("clientiditc")
      return {
        uid: `anon-${generateUUID()}`,
        email: typeof clientId === "string" ? clientId : String(clientId),
        displayName: "Anonymous",
        isAnonymous: true,
        providerId: "anonymous",
        emailVerified: false,
        generic: generic,
        metadata: {
          creationTime: new Date().toISOString(),
          lastSignInTime: new Date().toISOString(),
        },
      }; 
  } catch (error) { 
    console.error('Error al iniciar sesión anónimamente:', error);
    throw error;
  }
};

 



// Función para cerrar sesión
export const signOutFirebase = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Error al cerrar sesión:", error);
    throw error;
  }
};

// Verificar Expiracion del token
export const isTokenExpired = (token: string): boolean => {
  try {
    const decodedToken = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return decodedToken.exp < currentTime;
  } catch (error) {
    console.error("Error al decodificar el token:", error);
    return true;
  }
};

// retorna token emabse a variable de contexto
export const renewTokenIfExpired = async ( User:any ): Promise<string | null> => {
  try {
    const currentToken = await User.getIdToken(); 
    if (isTokenExpired(currentToken)) {
      const newToken = await User.getIdToken(true);
      User.accessToken = newToken;
      return newToken;
    } else { 
      return currentToken;
    }
  } catch (error) {
    console.error("Error al renovar el token:", error);
    throw error;
  }
};

 
 // Login con Google Drive y obtener token de acceso
 export const authorizeGoogleDrive = async () => {
  const provider = new GoogleAuthProvider();
  //provider.addScope("https://www.googleapis.com/auth/drive.readonly");
  //provider.addScope("https://www.googleapis.com/auth/drive.file");
  provider.addScope("https://www.googleapis.com/auth/drive");
  //provider.setCustomParameters({ prompt: "consent" });

  const result = await signInWithPopup(auth, provider);
  const credential = GoogleAuthProvider.credentialFromResult(result);
  if (!credential?.accessToken) {
    throw new Error("No se obtuvo accessToken de Drive");
  }
  return {
    user: result.user,
    accessToken: credential.accessToken,
    issuedAt: Date.now(),
  };
};